<app-section
  titleSection="Informations du bien"
  [isActivated]="informationsBien.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-informations-bien-read-mode [informationsBien]="informationsBien">
    </app-informations-bien-read-mode>
  </div>

  <div edit-mode>
    <app-informations-bien-edit-mode
      [informationsBien]="informationsBien"
      (informationsBienChanged)="onInformationsBienChanged($event)"
    >
    </app-informations-bien-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
